import React, { useContext } from "react";

import { Message, Segment } from "semantic-ui-react";
import ReportDisplay from "./ReportDisplay";
import ReportFilters from "./ReportFilters";

import { reportContext } from "contexts/ReportContext";

function ReportBody() {
	const reportData = useContext(reportContext);
	return (
		<Segment
			loading={reportData.loading}
			basic
			style={{
				paddingRight: "0px",
				paddingLeft: "0px",
			}}
		>
			{reportData.hasData ? (
				<>
					<ReportFilters />
					<ReportDisplay />
				</>
			) : (
				<Message>No record found.</Message>
			)}
		</Segment>
	);
}

export default ReportBody;
